import { UUID } from '../shared/UUID';
import { IPropertyAddressResponse } from '../address/IPropertyAddressResponse';
import { eLenderFeeType } from './ILenderInformation';

export interface ILenderCompanyResponse {
  id: UUID;
  createdAt: string;
  updatedAt: string;
  address: IPropertyAddressResponse;
  bulkRateQualified?: boolean;
  defaultFeeType: eLenderFeeType;
  masterEmail?: string;
  mortgageeClause?: string;
  name: string;
  refiDiscountedClosingFee: boolean;
  wfgId?: string;
  isActive: boolean;
}

export type ILenderCompanyData = ILenderCompanyResponse;

export const convertILenderCompanyResponseToILenderCompanyData = (
  response: ILenderCompanyResponse
): ILenderCompanyData => response;
